export default __webpack_public_path__ + "8dd27b508ddae9484c742a23aeb95cd9.svg";